import { CoreUiException } from "./core-ui-exception";

/**
 * Occurrs when an exception occurs in a service.
 *
 * Either the component should create a more specific exception,
 * or a generic error message will be displayed.
 */
export class ServiceException extends CoreUiException {

    constructor(message: string, originalError?: any) {

        super("ServiceException", message, originalError);

        // Work around for Error Extension
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, ServiceException.prototype);
    }
}
